// Copy overrides for the `vanguard_ascension_custom_experience` flipper.
// Keys mirror the non-Ascension structure in `patientRxAuth.ts` so consumers
// can swap the root object (e.g. `l.ascension.storeLandingPages.leftColumn` in
// place of `l.patientRxAuth.storeLandingPages.leftColumn`) without changing
// downstream keys. Keys that are Ascension-only additions (no non-Ascension
// counterpart) also live here.
export const ascension = {
  storeLandingPages: {
    leftColumn: {
      tips: "{{storeName}} trusts Fullscript to power their storefront. Here's why you should too:",
      carousel: {
        slide4:
          "Ascension collaborates with Fullscript to provide its patients with a convenient online storefront for purchasing supplements recommended by their Ascension providers. Patients may purchase recommended supplements through the Ascension St. Vincent storefront on Fullscript, which is a cash-pay-only platform, or any other pharmacy or retailer of their choice, as insurance benefits may be available for certain prescribed supplements. Ascension and its providers may benefit from supplement purchases made through the Fullscript platform, consistent with applicable policies and regulatory requirements.",
      },
    },
  },
} as const;
